module.exports = __webpack_public_path__ + "img/9H.24d13845.png";